import React, { useMemo } from 'react'

import IdeaPanel from 'components_newui/idea_panel/View';
import NxtCircularLoader from 'components/nxt_circular_loader/View';
import noIdeasImg from 'img/no_ideas.png';


export const UserIdeaList = (props) => {
    // console.log('props', props)
    const {classes,ideasLists}= props
    const ideaListData =  ideasLists.data || ideasLists || []

    const filteredDataMyIdeasList = useMemo(() => {
      return [...ideaListData || []].sort(
        (a, b) => (b?.created?.timestamp ?? 0) - (a?.created?.timestamp ?? 0)
      );
    }, [ideaListData]);


//  const listmyIdea = innovateMyIdeaList?.data || []

//  const sortedFiltered = React.useMemo(() => {
//    return [...listmyIdea].sort((a, b) => {
//      const aSelected = a.status === "SELECTED_FOR_HACKATHON";
//      const bSelected = b.status === "SELECTED_FOR_HACKATHON";
 
//      // Get timestamps for comparison
//      const aTimestamp = a.created?.timestamp || a.created || 0;
//      const bTimestamp = b.created?.timestamp || b.created || 0;
 
//      // If selection status differs, selected items come first
//      if (aSelected !== bSelected) {
//        return bSelected - aSelected; // true (1) - false (0) = 1, so selected comes first
//      }
 
//      // If same selection status, sort by date (newest first)
//      return bTimestamp - aTimestamp;
//    });
//  }, [listmyIdea]); 
 

const renderEmptyState = () => (
    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
      <img className={classes.noIdeaImg} style={{width:'200px'}} src={noIdeasImg} alt="no idea found" />
      <p className={classes.noIdeas}>
        No existing <span className={classes.purpleNo}>ideas</span>
      </p>
    </div>
);

    return (
      <div>
        {/* <h2>Idea lists</h2> */}
      {filteredDataMyIdeasList?.length > 0 ?
        <div className={classes.IdeaGrid}>
            { (filteredDataMyIdeasList)?.map(idea => (
                <IdeaPanel key={idea.id} idea={idea} urlId={idea.id} />
              ))
            }
        </div>
        :  renderEmptyState()
        }
        </div>
    )
}

